import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { Admin, Details } from 'pages/admin';
import { AppConfig } from 'types';
import { AppContext, AppProvider } from 'providers/AppProvider';
import { ApplicationContext, ApplicationProvider } from 'providers/ApplicationProvider';
import { Authenticate } from 'pages/authenticate/Authenticate';
import { Curity } from 'pages/curity/Curity';
import { PageDefinition, ROUTES, SWR_CONFIG } from 'consts';
import { Template, User } from 'components';
import { Waiver } from 'pages/waiver/Waiver';

export function AppRoutes({ config }: Readonly<{ config: AppConfig }>) {
	return (
		<ApplicationContext.Provider value={ApplicationProvider(config)}>
			<BrowserRouter>
				<Routes>
					{config.IS_EMPLOYEE_WEB && (
						<>
							<Route element={<Element Page={Admin} path="" />} path="/admin" />
							<Route element={<Element Page={Details} path="" />} path="/admin/details/:agreementProcessId" />
						</>
					)}
					<Route element={<Element Page={Authenticate} path="" />} path="/:flowType/authenticate" />
					<Route element={<Element Page={Curity} path="" />} path="/curity" />
					<Route element={<Element Page={Waiver} path="" />} path="/waiver-confirmation/:token?" />
					<Route path="/:flowType/:entityType">{ROUTES.map(Page)}</Route>
					<Route element={<Navigate to="/mv/authenticate" replace={true} />} path="*" />
				</Routes>
			</BrowserRouter>
		</ApplicationContext.Provider>
	);
}

function Page(props: PageDefinition) {
	return <Route element={<Element {...props} />} key={props.path} path={props.path} />;
}

function Element(props: PageDefinition) {
	const ctx = AppProvider();
	return (
		<SWRConfig value={{ ...SWR_CONFIG, fetcher: ctx.http.fetcher }}>
			<AppContext.Provider value={ctx}>
				<User>
					<Template>
						<props.Page />
					</Template>
				</User>
			</AppContext.Provider>
		</SWRConfig>
	);
}
